<script setup>
defineProps(['message']);
</script>

<template>
    <div v-if="message">
        <p class="font-bold text-sm text-orange-600 input-error">
            {{ message }}
        </p>
    </div>
</template>
